// ======================================================================
// File Name       : SuperUserCheck
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Modal, Button } from "react-bootstrap";
import SuperUserDetail from "./SuperUserDetail";
import { MODE, MODAL_SIZE } from "../../constants/index";

class SuperUserCheckContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: MODE.NEW_MODE,
      showCheck: false,
      superuserDetail: {},
      enterpriseList: [],
      enterpriseInfo: {},
      allServiceCdRoleList: [],
      superuserRoleList: {},
      superuserAllServiceRoleList: {},
      superuserAllEnterpriseRoleList: {},
      showLoginIdPasswordSendFlag: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.superuserDetail) {
      const {
        mode,
        showCheck,
        superuserDetail,
        enterpriseList,
        enterpriseInfo,
        allServiceCdRoleList,
        superuserRoleList,
        superuserAllServiceRoleList,
        allServiceRelation,
        superuserAllEnterpriseRoleList,
        serviceCdListSorted,
      } = nextProps;
      this.setState({
        mode,
        showCheck,
        superuserDetail,
        enterpriseList,
        enterpriseInfo,
        allServiceCdRoleList,
        superuserRoleList,
        superuserAllServiceRoleList,
        allServiceRelation,
        superuserAllEnterpriseRoleList,
        serviceCdListSorted,
      });
    }
  }

  render() {
    const style = {
      background: "none",
      width: "auto",
      marginLeft: 0,
      left: 0
    };
    return (
      <Modal
        className="modal-container"
        show={this.state.showCheck}
        onHide={this.props.onCancel}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            以下の内容で登録します
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SuperUserDetail {...this.state} isCheck />
        </Modal.Body>
        <Modal.Footer>
          <Col sm={12} className="text-center">
            <Button
              className="btn-96 margin-10"
              onClick={this.props.onCancel}
            >
              キャンセル
            </Button>
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.props.onOK.bind(this)}
            >
              OK
            </Button>
          </Col>

        </Modal.Footer>
      </Modal>
    );
  }
}

export default SuperUserCheckContainer;
